export default {
    // base: '/activity',
    // mode: 'history',
    routes: [
        {
            path: '/account/notify/:status',
            name: 'account-notify',
            component: () =>
                import(
                    /* webpackChunkName: "pages/account/notify" */ '../pages/account/notify.vue'
                ),
            meta: { keepAlive: false, title: '账号绑定通知', noTpl: true },
        },

        // v4官网
        {
            path: '*',
            redirect: '/center/layout',
        },
        {
            path: '/center/layout',
            name: 'v4',
            component: () =>
                import(
                    /* webpackChunkName: "pages/v4/layout" */ '../pages/v4/layout.vue'
                ),
            meta: { keepAlive: true, title: '首页', noTpl: true },
            redirect: '/center/personal',
            children: [
                {
                    path: '/center/contribute/contribute',
                    name: 'v4-contribute-contribute',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/contribute" */ '../pages/v4/contribute/contribute.vue'
                        ),
                    meta: { keepAlive: false, title: '自由投稿', noTpl: true },
                },
                {
                    path: '/center/contribute/activity/:signature',
                    name: 'v4-contribute-activity',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/contribute/activity/contribute" */ '../pages/v4/contribute/activity/contribute.vue'
                        ),
                    meta: { keepAlive: false, title: '活动投稿', noTpl: true },
                },
                {
                    path: '/center/v3/contribute',
                    name: 'v3-contribute',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v3_contribute/contribute" */ '../pages/v4/v3_contribute/contribute/order_contribute.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏玩家创作联盟',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/v3/manage',
                    name: 'v3-manage',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v3_manage/content" */ '../pages/v4/v3_manage/content.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏玩家创作联盟',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/order/index',
                    name: 'v4-order-index',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/order" */ '../pages/v4/order/order_blank.vue'
                        ),
                    meta: { keepAlive: false, title: '订单投稿', noTpl: true },
                    redirect: 'v4-order-order',
                    children: [
                        {
                            path: '/center/order/order',
                            name: 'v4-order-order',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/order" */ '../pages/v4/order/order.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '个人外团派单',
                                noTpl: true,
                            },
                            redirect: '/center/order/supplier',
                            children: [
                                {
                                    path: '/center/order/supplier',
                                    name: 'v4-order-supplier',
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/demand.vue'
                                        ),
                                    meta: {
                                        keepAlive: false,
                                        title: '订单投稿-供应商订单-需求单页面',
                                        noTpl: true,
                                    },
                                },
                                {
                                    path: '/center/order/author/order/list',
                                    name: 'v4-order-author-order-list',
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/author_order_list.vue'
                                        ),
                                    meta: {
                                        keepAlive: false,
                                        title: '订单投稿-作者-作者订单列表页',
                                        noTpl: true,
                                    },
                                },
                                {
                                    path: '/center/order/personal',
                                    name: 'v4-order-personal',
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "pages/v4/order" */ '../pages/v4/order/person_order/personal_order.vue'
                                        ),
                                    meta: {
                                        keepAlive: false,
                                        title: '订单投稿-个人订单',
                                        noTpl: true,
                                    },
                                },
                                {
                                    path: '/center/order/demand',
                                    name: 'v4-order-demand',
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/demand.vue'
                                        ),
                                    meta: {
                                        keepAlive: false,
                                        title: '订单投稿-供应商订单-需求单页面',
                                        noTpl: true,
                                    },
                                },
                            ],
                        },
                        {
                            path: '/center/order/person/content/detail',
                            name: 'v4-order-person-content-detail',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/order" */ '../pages/v4/order/person_order/person_order_content_detail.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-订单详情(内容)',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/person/service/detail',
                            name: 'v4-order-person-service-detail',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/order" */ '../pages/v4/order/person_order/person_order_service_detail.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-订单详情(劳务福利补贴)',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/contribute',
                            name: 'v4-order-contribute',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/orderContribute" */ '../pages/v4/order/contribute/order_contribute.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿',
                                noTpl: true,
                            },
                        },
                        /*供应商订单*/
                        {
                            path: '/center/order/supplier/detail/pugc',
                            name: 'v4-order-supplier-detail-pugc',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/order_detail_pugc_pgc.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-供应商订单-pugc详情页',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/demand/detail/ugc',
                            name: 'v4-order-demand-detail-ugc',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/demand_detail_ugc.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-供应商需求单-ugc详情页',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/supplier/detail/ugc',
                            name: 'v4-order-supplier-detail-ugc',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/supplier_order_detail_ugc.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-供应商子订单-作者订单列表页',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/author/detail/ugc',
                            name: 'v4-order-author-detail-ugc',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/supplier_order_detail_ugc.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-作者订单-ugc详情页',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/supplier/unpack',
                            name: 'v4-order-supplier-unpack',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/order_unpack.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-供应商订单-ugc拆单页',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/order/related/author/charge',
                            name: 'v4-order-related-author-charge',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/supplierOrder" */ '../pages/v4/order/supplier_order/related_author_charge.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '订单投稿-供应商订单-ugc详情页',
                                noTpl: true,
                            },
                        },
                    ],
                },
                {
                    path: '/center/task',
                    name: 'v4-task',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/contribute/task" */ '../pages/v4/contribute/task.vue'
                        ),
                    meta: { keepAlive: false, title: '活动广场', noTpl: true },
                    redirect: '/center/task/playground',
                    children: [
                        {
                            path: '/center/task/playground',
                            name: 'v4-task-playground',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/contribute/task" */ '../pages/v4/contribute/task_playground.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '活动广场',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/task/:taskId/picture/:articleId?',
                            name: 'v4-task-picture',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/contribute/task" */ '../pages/v4/contribute/task_picture.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '活动图文投稿',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/task/:taskId/video/:articleId?',
                            name: 'v4-task-video',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/contribute/task" */ '../pages/v4/contribute/task_video.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '活动视频投稿',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/task/detail/:detailId',
                            name: 'v4-task-detail',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/contribute/task" */ '../pages/v4/contribute/task_detail.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '活动详情',
                                noTpl: true,
                            },
                        },
                    ],
                },
                {
                    path: '/center/manage/content/:tabId?',
                    name: 'v4-manage-content',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/manage" */ '../pages/v4/manage/content.vue'
                        ),
                    meta: { keepAlive: false, title: '我的内容', noTpl: true },
                },
                {
                    path: '/center/manage/account',
                    name: 'v4-manage-account',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/manage" */ '../pages/v4/manage/account.vue'
                        ),
                    meta: { keepAlive: false, title: '媒体账号', noTpl: true },
                },
                {
                    path: '/center/manage/team',
                    name: 'v4-manage-team',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/manage" */ '../pages/v4/manage/team.vue'
                        ),
                    meta: { keepAlive: false, title: '团队管理', noTpl: true },
                },
                {
                    path: '/center/laboratory/material',
                    name: 'v4-laboratory-material',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/material.vue'
                        ),
                    meta: { keepAlive: false, title: '正版素材', noTpl: true },
                },
                {
                    path: '/center/laboratory/radar',
                    name: 'v4-laboratory-radar',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/radar.vue'
                        ),
                    meta: { keepAlive: false, title: '热点雷达', noTpl: true },
                    redirect: '/center/laboratory/radar/trend',
                    children: [
                        {
                            path: '/center/laboratory/radar/trend',
                            name: 'v4-laboratory-radar-trend',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/radar_trend.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '热点雷达-内容趋势',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/laboratory/radar/word',
                            name: 'v4-laboratory-radar-word',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/radar_word.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '热点雷达-热点词汇',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/laboratory/radar/video',
                            name: 'v4-laboratory-radar-video',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/radar_video.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '热点雷达-热点视频',
                                noTpl: true,
                            },
                        },
                        {
                            path: '/center/laboratory/radar/detail',
                            name: 'v4-laboratory-radar-detail',
                            component: () =>
                                import(
                                    /* webpackChunkName: "pages/v4/laboratory" */ '../pages/v4/laboratory/radar_detail.vue'
                                ),
                            meta: {
                                keepAlive: false,
                                title: '热点雷达-热点分析',
                                noTpl: true,
                            },
                        },
                    ],
                },
                {
                    path: '/center/information/content',
                    name: 'v4-information-content',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/information" */ '../pages/v4/information/content.vue'
                        ),
                    meta: { keepAlive: false, title: '内容数据', noTpl: true },
                },
                {
                    path: '/center/profit/profit',
                    name: 'v4-profit-profit',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/profit" */ '../pages/v4/profit/profit.vue'
                        ),
                    meta: { keepAlive: false, title: '收益结算', noTpl: true },
                },
                {
                    path: '/center/admire/apply',
                    name: 'v4-admire-apply',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/admire" */ '../pages/v4/admire/apply.vue'
                        ),
                    meta: { keepAlive: false, title: '赞赏申请', noTpl: true },
                },
                {
                    path: '/center/extension/apply',
                    name: 'v4-extension-apply',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/extension" */ '../pages/v4/extension/apply.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '游戏推广申请',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/extension/manage',
                    name: 'v4-extension-manage',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/extension" */ '../pages/v4/extension/manage.vue'
                        ),
                    meta: { keepAlive: false, title: '游戏推广', noTpl: true },
                },
                {
                    path: '/center/extension/detail',
                    name: 'v4-extension-detail',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/extension" */ '../pages/v4/extension/task_detail.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '游戏推广详情',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/extension/edit',
                    name: 'v4-extension-edit',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/extension" */ '../pages/v4/extension/edit.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '游戏推广详情',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/admire/manage',
                    name: 'v4-admire-manage',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/admire" */ '../pages/v4/admire/index.vue'
                        ),
                    meta: { keepAlive: false, title: '赞赏功能', noTpl: true },
                },
                {
                    path: '/center/set/account',
                    name: 'v4-set-account',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/set" */ '../pages/v4/set/account_settings.vue'
                        ),
                    meta: { keepAlive: false, title: '账户设置', noTpl: true },
                },
                {
                    path: '/center/mcn/enter',
                    name: 'v4-mcn-enter',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/set" */ '../pages/v4/set/mcn_enter.vue'
                        ),
                    meta: { keepAlive: false, title: 'MCN入驻', noTpl: true },
                },
                {
                    path: '/center/open/create',
                    name: 'v4-open-create',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/open" */ '../pages/v4/open/app_create.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '开放平台账号申请',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/open/auth',
                    name: 'v4-open-auth',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/open/auth" */ '../pages/v4/open/app_auth.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '开放平台账号授权',
                        noTpl: true,
                    },
                },
                {
                    path: '/center/check/free',
                    name: 'v4-check-free',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/check" */ '../pages/v4/check/free.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '自由投稿审核',
                        noTpl: true,
                        nomenu: true,
                    },
                },
                {
                    path: '/center/check/task',
                    name: 'v4-check-task',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/check" */ '../pages/v4/check/task.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '活动投稿审核',
                        noTpl: true,
                        nomenu: true,
                    },
                },
                {
                    path: '/center/personal',
                    name: 'v4-personal-personal',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/personal" */ '../pages/v4/personal/personal.vue'
                        ),
                    meta: { keepAlive: false, title: '个人中心', noTpl: true },
                },
                {
                    path: '/center/notice/detail/:id',
                    name: 'v4-notice-detail',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/personal" */ '../pages/v4/personal/notice_detail.vue'
                        ),
                    meta: { keepAlive: false, title: '公告详情', noTpl: true },
                },
                {
                    path: '/center/white',
                    name: 'v4-white',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/white" */ '../pages/v4/white/white.vue'
                        ),
                    meta: { keepAlive: false, title: '审核', noTpl: true },
                },
                {
                    path: '/center/cme',
                    name: 'center-cme',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/cme/manage" */ '../pages/v4/cme/manage.vue'
                        ),
                    meta: { keepAlive: true, title: '视频管理', noTpl: true },
                },
                // 微前端路由
                // {
                //     path: '/material/:type',
                //     name: 'material-center',
                //     component: () =>
                //         import(
                //             /* webpackChunkName: "pages/v4/material" */ '../pages/v4/frame/index.vue'
                //         ),
                //     meta: { keepAlive: true, title: '素材中心', noTpl: true },
                // },

                // iframe路由
                {
                    path: '/mc/:type',
                    name: 'material-center',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/material" */ '../pages/v4/material/index.vue'
                        ),
                    meta: { keepAlive: true, title: '素材中心', noTpl: true },
                },
            ],
        },

        {
            path: '/center/layout_full',
            name: 'layout-full',
            component: () =>
                import(
                    /* webpackChunkName: "pages/v4/layout_full" */ '../pages/v4/layout_full.vue'
                ),
            meta: { keepAlive: true, title: '首页', noTpl: true },
            children: [
                {
                    path: '/center/auth/authorize',
                    name: 'authorize',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/auth/authorize" */ '../pages/v4/auth/authorize.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏玩家创作联盟-授权',
                        noTpl: true,
                        needLogin: false,
                        noLoginBtn: true,
                        alone: true,
                    },
                },
                {
                    path: '/center/auth/login',
                    name: 'v4-auth-login',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/auth/login" */ '../pages/v4/auth/login.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏玩家创作联盟-授权',
                        noTpl: true,
                        needLogin: false,
                        noLoginBtn: true,
                        alone: true,
                    },
                },
                {
                    path: '/center/activity/school_creator',
                    name: 'school_creator',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/school_creator" */ '../pages/v4/activity/school_creator.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏高校创作星',
                        noTpl: true,
                        needLogin: false,
                    },
                },
                {
                    path: '/center/activity/school_winner',
                    name: 'school_winner',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/school_winner" */ '../pages/v4/activity/school_winner.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '腾讯游戏高校创作星获奖公示',
                        noTpl: true,
                        needLogin: false,
                    },
                },
                {
                    path: '/center/activity/cf/pc',
                    name: 'school_creator',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/cf/pc" */ '../pages/v4/activity/cf/pc/index.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: 'CF创作大赛',
                        noTpl: true,
                        needLogin: false,
                        disableLoginType: 'wx',
                    },
                },
                {
                    path: '/center/activity/cf/kuaishou',
                    name: 'school_creator',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/cf/kuaishou" */ '../pages/v4/activity/cf/pc/kuaishou.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: 'CF创作大赛',
                        noTpl: true,
                        needLogin: false,
                    },
                },
                {
                    path: '/center/activity/demon',
                    name: 'activity_demon',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/demon" */ '../pages/v4/activity/demon.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '一起来抓妖',
                        noTpl: true,
                        needLogin: false,
                    },
                },
                {
                    path: '/center/activity/:id',
                    name: 'activity_config',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/config" */ '../pages/v4/activity/config.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: '活动首页',
                        noTpl: true,
                        needLogin: false,
                    },
                },
            ],
        },
        {
            path: '/center/layout_activity',
            name: 'layout-activity',
            component: () =>
                import(
                    /* webpackChunkName: "pages/v4/layout_activity" */ '../pages/v4/layout_activity.vue'
                ),
            meta: { keepAlive: true, title: '活动首页', noTpl: true },
            children: [
                {
                    path: '/center/activity/cf/m',
                    name: 'school_creator',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/cf/m" */ '../pages/v4/activity/cf/m/index.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: 'CF创作大赛',
                        noTpl: true,
                        needLogin: false,
                    },
                },
                {
                    path: '/center/activity/cf/kuaishoum',
                    name: 'school_creator',
                    component: () =>
                        import(
                            /* webpackChunkName: "pages/v4/activity/cf/kuaishoum" */ '../pages/v4/activity/cf/m/kuaishou.vue'
                        ),
                    meta: {
                        keepAlive: false,
                        title: 'CF创作大赛',
                        noTpl: true,
                        needLogin: false,
                    },
                },
            ],
        },

        {
            path: '/center/cme/edit',
            name: 'center-cme-edit',
            component: () =>
                import(
                    /* webpackChunkName: "pages/v4/cme/edit" */ '../pages/v4/cme/edit.vue'
                ),
            meta: { keepAlive: true, title: '视频编辑', noTpl: true },
        },
        // {
        //     path: '/center/cme/editComponent',
        //     name: 'center-cme-editComponent',
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "pages/v4/cme/editComponent" */ '../pages/v4/cme/editComponent.vue'
        //         ),
        //     meta: { keepAlive: true, title: '组件视频编辑', noTpl: true },
        // },
    ],
};
